/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-12-15 08:48:29
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-15 14:52:11
 * @FilePath: \mpc-3\apps\mpc-external\src\containers\Main\RouteRegister.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Spin } from '@bedrock/components';
import { AccountState, MenuType, MenuRouteType } from 'modules/types/account';
import { ProjectDetailDrawer, ProjectDetailSingle } from '../SmWorkbench/ProjectDetail';
import { ProjectDetailDrawer as LsProjectDetailDrawer } from '../LsWorkbench/ProjectDetail';
import { ProjectDetailDrawer as NewProjectDetailDrawer } from '../OutWorkbench/ProjectDetail';
import OutWorkbenchList from '../OutWorkbench/index';
import {
  ProjectDetailDrawer as BiddingProjectDetailDrawer,
  ProjectDetailSingle as BiddingProjectDetailSingle,
} from '../OutBidding/ProjectDetail';
import PrePaymentDetailDrawer from '@mpc/common/src/features/PrePayment/OuterDrawer';
import NotFound from '../404';
import DemoEntry from '../Demo';
import { demoRoutes, isDemoMode } from '../../demo-routes';
import { DemoWrapper } from '@mpc/common/src/devtools/demo-router';

// 懒加载包装器（带 DemoWrapper）
const createLazyComponent = (importFn: () => Promise<any>, title?: string) => {
  const LazyComponent = lazy(importFn);
  return () => (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen">
          <Spin size="large" />
        </div>
      }
    >
      <DemoWrapper title={title}>
        <LazyComponent />
      </DemoWrapper>
    </Suspense>
  );
};

export default function RouteRegister(props: any) {
  const { menuRoutes, location: { search, pathname }, leftSideWidth } = props;
  
  // 生产模式不渲染 Demo 路由
  const demoRouteElements = isDemoMode ? (
    <>
      {/* Demo 统一入口 */}
      <Route path="/demos" exact component={DemoEntry} />
      
      {/* 各个 Demo 路由 */}
      {demoRoutes.map((route: any) => {
        const LazyComponent = createLazyComponent(route.component, route.title);
        return <Route key={route.path} path={route.path} component={LazyComponent} />;
      })}
    </>
  ) : null;
  
  return (
    <>
      <Switch>
        {/* <Route
          path="/outWorkbench/:path"
          component={OutWorkbenchList}
        />
        <Redirect
          from="/outWorkbench"
          to="/outWorkbench/outPendingQuote"
        /> */}
        {menuRoutes.map((route: MenuRouteType, idx: number) => {
          const Component = route.component;         
          const c =
            route.redirect || !route.component ? (
              <Redirect
                exact
                key={idx}
                from={'/' + route.parentRoutePath}
                to={{ pathname: '/' + route.routePath, search }}
              />
            ) : (
              <Route
                // key={idx}
                path={'/' + route.routePath}
                // @ts-ignore
                render= {(remderProps) => <Component {...props} {...remderProps} childMenus={route.childMenus} />}
              />
            );
          return c;
        })}
        <Route
          path="/smWorkbench/projectDetailSingle/:id"
          component={ProjectDetailSingle}
        />
        <Route
          path="/outBidding/projectDetailSingle/:id"
          component={BiddingProjectDetailSingle}
        />
        <Route path="*" component={NotFound} />
      </Switch>
      <Route path="/smWorkbench/" component={ProjectDetailDrawer} />
      <Route path="/lsWorkbench/" component={LsProjectDetailDrawer} />
      <Route path="/outWorkbench/" component={NewProjectDetailDrawer} />
      <Route path="/outWorkbenchPortal/outNormalPurchase" component={NewProjectDetailDrawer} />
      <Route path="/outWorkbenchPortal/outBiddingPurchase" component={BiddingProjectDetailDrawer} />
      <Route path="/outWorkbenchPortal/outPrepayment" component={PrePaymentDetailDrawer} />
      <Route
        path="/outBidding/"
        render={(props: any) => (
          <BiddingProjectDetailDrawer
            {...props}
            leftSideWidth={leftSideWidth}
          />
        )}
      />



      {/* Demo 路由 - 要放在最后面，避免影响其他路由 */}
      {demoRouteElements}
    </>
  )
}
